/** @format */

import React from 'react';
import config from 'config';
import { useTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';
import RoutedComponent from 'components/RoutedComponent';
import { Helmet } from 'react-helmet-async';

/** Containers sorted according to the registration flow order */

/**
 * Common views
 */
import PageNotFound from 'views/Static/PageNotFound';
import Login from 'views/Broker/Login';
import ChangePassword from 'views/Broker/ChangePassword';
import Dashboard from 'views/Broker/Dashboard';

/**
 * Brokers Profile view
 */

import BrokerProfile from 'views/Broker/Profile/BrokerProfile';
import ObjectListing from 'views/Broker/Profile/ObjectListing';
import ViewImages from 'views/Broker/Profile/ViewImages';

const {
  constants: { flows, views, flowOrigins }
} = config;

const commonProps = {
  flow: flows.broker,
  flowOrigin: flowOrigins.broker
};

export default function Routes() {
  const { t } = useTranslation();
  const seoCommonTitle = t('lang_common:seo.title.common.text');
  const seoDescription = t('lang_common:seo.title.common.description.text');

  return (
    <>
      <Helmet>
        <title>{seoCommonTitle} </title>
        <link rel='canonical' href={window.location.origin} />
        <meta name='description' content={seoDescription} />
      </Helmet>
      <Switch>
        <RoutedComponent /*** Dashboard ***/
          exact={true}
          isPrivateRoute={true}
          Component={Dashboard}
          view={views.dashboard}
          path={t(`lang_route:broker_dashboard`)}
          {...commonProps}
        />
        <RoutedComponent /*** Login ***/
          exact={true}
          isPrivateRoute={false}
          Component={Login}
          view={views.login}
          path={t(`lang_route:broker_login`)}
          {...commonProps}
        />

        <RoutedComponent /*** Forgot Password ***/
          exact={true}
          isPrivateRoute={false}
          Component={ChangePassword}
          view={views.changePassword}
          path={t(`lang_route:broker_change_password`)}
          {...commonProps}
        />

        <RoutedComponent /*** view broker profile page ***/
          exact={true}
          isPrivateRoute={true}
          Component={BrokerProfile}
          view={views.broker_profile}
          path={`${t(`lang_route:common_broker_profile`)}/:profileSlug`}
          flow={flows.common}
          flowOrigin={flowOrigins.common}
        />

        <RoutedComponent /*** view broker profile page ***/
          exact={false}
          isPrivateRoute={true}
          Component={BrokerProfile}
          view={views.broker_profile}
          path={t(`lang_route:common_broker_profile`)}
          flow={flows.common}
          flowOrigin={flowOrigins.common}
        />

        <RoutedComponent /*** view object listings page ***/
          exact={false}
          isPrivateRoute={true}
          Component={ObjectListing}
          view={views.object_listing}
          path={t(`lang_route:common_object_listing`)}
          flow={flows.common}
          flowOrigin={flowOrigins.common}
        />

        <RoutedComponent /*** view object images page ***/
          exact={false}
          isPrivateRoute={true}
          Component={ViewImages}
          view={views.object_view_images}
          path={t(`lang_route:common_object_view_images`)}
          flow={flows.common}
          flowOrigin={flowOrigins.common}
        />

        <Route>
          <PageNotFound flow={flows.common} view={views.page_not_found} />
        </Route>
      </Switch>
    </>
  );
}
